import React, { useState, useEffect } from 'react';
import ProfDashboardLayout from './ProfDashboardLayout'
import ProfMultiStepForm from '../../../components/ProfessionalComponents/ProfMultiStepForm/ProfMultiStepForm'
import { useDispatch, useSelector } from 'react-redux';
import { ProfessionalAddTimingsAPI, ProfessionalDeleteSchaduleAPI, ProfessionalShowTimingsAPI, UpdateProfessionalTimeAPI } from '../../../redux/slices/ProfessionalSheduleSlice';
import { toast } from 'react-toastify';
import { errorHandler } from '../../../constants/base';

const MySchedule = () => {

    const dispatch = useDispatch();
    const user = useSelector((state) => state?.AuthSlice?.user);
    const allTimings = useSelector((state) => state?.ProfessionalSheduleSlice?.allTimings)
    const loading = useSelector((state) => state?.ProfessionalSheduleSlice?.loading)
    const timeLoading = useSelector((state) => state?.ProfessionalSheduleSlice?.timeLoading)
    const [isValid, setIsValid] = useState(false);
    const [showTimeInputs, setShowTimeInputs] = useState(false)

    const fetchData = async () => {
        if (allTimings.length === 0) {
            try {
                await dispatch(ProfessionalShowTimingsAPI(user));
            } catch (error) {
                console.error("Error fetching timings:", error);
            }
        };
    }

    useEffect(() => {
        fetchData()
    }, [allTimings.length])


    const [formData, setFormData] = useState({
        day: '',
        start_time: '',
        end_time: '',
        user_id: user?.id,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedFormData = { ...formData, [name]: value };
        setFormData(updatedFormData);

        // Validate the form
        validateForm(updatedFormData);
        setShowTimeInputs(true)
    };

    const validateForm = (data) => {
        const isFormValid = data.day && data.start_time && data.end_time;
        setIsValid(isFormValid);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await dispatch(ProfessionalAddTimingsAPI(formData))
        if (res?.payload?.status === 200) {
            toast.success("Time Slote Add Successfully")
            await dispatch(ProfessionalShowTimingsAPI(user))
            setShowTimeInputs(false)
        }
        setFormData({
            day: '',
            start_time: '',
            end_time: '',
            user_id: user?.id,
        });

        setIsValid(false);
    };

    // EDIT TIME SLOTS

    const [editableItem, setEditableItem] = useState(null);
    const [updatedData, setUpdatedData] = useState({});

    const formatTimeToInput = (time) => {
        if (!time) return "00:00";
        const [hours, minutes] = time.split(":");
        return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
    };

    const enableEdit = (item) => {
        setEditableItem(item.id);
        setUpdatedData({
            start_time: item.start_time,
            end_time: item.end_time,
            // day: item.day,
            user_id: user?.id,
            schedule_id: item?.id
        });
    };

    const handleTimeChange = (e, field) => {
        setUpdatedData((prev) => ({
            ...prev,
            [field]: e.target.value,
        }));
    };

    const updateTimeSlot = async () => {
        const formattedStartTime = formatTimeToInput(updatedData.start_time);
        const formattedEndTime = formatTimeToInput(updatedData.end_time);

        // Skip the API call if the times weren't actually changed
        const originalItem = allTimings.find((item) => item.id === editableItem);
        const originalStartTime = originalItem ? formatTimeToInput(originalItem.start_time) : null;
        const originalEndTime = originalItem ? formatTimeToInput(originalItem.end_time) : null;

        if (formattedStartTime === originalStartTime && formattedEndTime === originalEndTime) {
            setEditableItem(null);
            return;
        }

        const updatedDataForApi = {
            ...updatedData,
            start_time: formattedStartTime,
            end_time: formattedEndTime,
        };
        const res = await dispatch(UpdateProfessionalTimeAPI(updatedDataForApi))
        if (res?.payload?.status === 200) {
            toast.success("Time Slote Update Successfully")
            await dispatch(ProfessionalShowTimingsAPI(user))
            setEditableItem(null);
        }
        setEditableItem(null);
    };


    // DELTE SCHADULE

    const [loadingId, setLoadingId] = useState(null);

    const deleteSchedule = async (id) => {
        setLoadingId(id);

        try {
            const res = await dispatch(ProfessionalDeleteSchaduleAPI(id))
            if (ProfessionalDeleteSchaduleAPI.fulfilled(res)) {
                toast.success("Schedule deleted successfully!");
                await dispatch(ProfessionalShowTimingsAPI(user));
            } else if (ProfessionalDeleteSchaduleAPI.rejected(res)) {
                toast.error("Something went wrong");
            }

        } catch (error) {
            toast.error("Failed to delete schedule.");
            console.error(error);
        } finally {
            setLoadingId(null);
        }
    }
    // DELTE SCHADULE


    if (loading && allTimings.length === 0) {
        return (
            <ProfDashboardLayout>
                <div className="text-center p-5">
                    <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "32px" }}></i>
                    <p className="mt-3">Loading schedule...</p>
                </div>
            </ProfDashboardLayout>
        );
    }

    return (
        <>
            <ProfDashboardLayout>
                <div className="add-employee-box">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="employee-form-box">
                                    <h1 className="mb-3">Work days & Time</h1>
                                </div>

                                <h3 className="second-text-heading">Select Week Days:</h3>

                                <form onSubmit={handleSubmit}>
                                    <div className="checkbox-group-blocks-label-wrap">
                                        <ul>
                                            {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day) => (
                                                <li key={day}>
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="day"
                                                            value={day}
                                                            checked={formData.day === day}
                                                            onChange={handleInputChange}
                                                        />
                                                        <span className="label-text">{day}</span>
                                                    </label>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    {showTimeInputs ? <div>
                                        <h3 className="second-text-heading mb-0">Select Timings:</h3>
                                        <div className="flex-align-box-shedule">
                                            <div className="select-timings-input">
                                                <label htmlFor="selectStartTiming">Start Time</label>
                                                <input
                                                    type="time"
                                                    name="start_time"
                                                    placeholder="Start Time"
                                                    id="selectStartTiming"
                                                    onChange={handleInputChange}
                                                />
                                            </div>

                                            <div className="select-timings-input mt-2">
                                                <label htmlFor="selectEndTiming">End Time</label>
                                                <input
                                                    type="time"
                                                    name="end_time"
                                                    placeholder="End Time"
                                                    id="selectEndTiming"
                                                    onChange={handleInputChange}
                                                />
                                            </div>

                                            <div className="d-flex justify-content-end">
                                                <button type="submit" disabled={!isValid || loading} className="btn btn-primary ps-3 pe-3" id="nextBtn">
                                                    {!loading ? (
                                                        "Add Time"
                                                    ) : (
                                                        <i
                                                            style={{ fontSize: "22px" }}
                                                            className="fa-solid fa-spinner fa-spin"
                                                        ></i>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </div> : ""}
                                </form>

                                <div className="time-slots">
                                    {allTimings.length > 0 && (
                                        <h3 className="second-text-heading mt-0 mb-4">Timings:</h3>
                                    )}

                                    {allTimings.map((item) => (
                                        <div key={item.id} className="time-slot-day">
                                            <h3 className="time-slot-heading-box">{item.day}</h3>

                                            <div className="show-time-slots">
                                                <input
                                                    type="time"
                                                    disabled={editableItem !== item.id}
                                                    value={editableItem === item.id ? updatedData.start_time : formatTimeToInput(item.start_time)}
                                                    onChange={(e) => handleTimeChange(e, "start_time")}
                                                />
                                                <span>to</span>
                                                <input
                                                    type="time"
                                                    disabled={editableItem !== item.id}
                                                    value={editableItem === item.id ? updatedData.end_time : formatTimeToInput(item.end_time)}
                                                    onChange={(e) => handleTimeChange(e, "end_time")}
                                                />
                                                {editableItem === item.id ? (
                                                    <div>
                                                        {!timeLoading ? (
                                                            <i className="fa-solid fa-check" onClick={updateTimeSlot}></i>
                                                        ) : (
                                                            <i
                                                                style={{ fontSize: "22px" }}
                                                                className="fa-solid fa-spinner fa-spin"
                                                            ></i>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className='d-flex'>
                                                        <i className="fa-solid fa-pen-to-square" onClick={() => enableEdit(item)}></i>

                                                        {!loadingId || loadingId !== item.id ? (
                                                            <i
                                                                className="fa-solid fa-trash"
                                                                onClick={() => deleteSchedule(item.id)}
                                                                style={{ color: "red" }}
                                                            ></i>
                                                        ) : (
                                                            <i
                                                                style={{ fontSize: "22px", color: "red" }}
                                                                className="fa-solid fa-spinner fa-spin"
                                                            ></i>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </ProfDashboardLayout >
        </>
    )
}

export default MySchedule